export default "__VITE_ASSET__BV6bmKGn__"